﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_informationNoHeader from './tpl/informationNoHeader.html';
import View_InformationNoHeaderList from './informationNoHeaderList';

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_informationNoHeader();
    },
    initialize: function () {
        this.listenTo(this.collection, 'change', this.setVisible);
    },
    regions: {
        informationNoHeaderList: "#informationNoHeaderList"
    },
    ui: {
        'informationNoHeader_content': '#information_content',
        'informationNoHeaderHeader_strong' : '#informationNoHeaderHeader_strong'
    },
    onBeforeShow: function () {
        this.informationNoHeaderList.show(new View_InformationNoHeaderList({ collection: this.collection }));
    },
    onRender: function () {
        this.setVisible();

        if (!this.options.enableHeader) {
            this.ui.informationNoHeaderHeader_strong.css('display', 'none');
        }
    },
    setVisible: function () {
        if (this.collection.length > 0) {
            this.ui.informationNoHeader_content.show();
        }
        else {
            this.ui.informationNoHeader_content.css('display', 'none');
        }
    }
});
